import { FC, useMemo } from 'react';

import { LearnMoreModal } from '@/components';
import { useLearnMoreModal } from '@/hooks';

import { Faster } from './faster';
import { InsuranceCompaniesList } from './insurance-companies-list';
import { Safer } from './safer';

const stepsList = [
  {
    title: 'Aceita pelas seguradoras',
    subtitle: 'Validações feitas pela Skymark, nossa GR parceira. Homologada e aceita por todas as seguradoras.',
    icon: 'one-check',
    children: <InsuranceCompaniesList />,
  },
  {
    title: 'Mais rápida',
    icon: 'clock',
    children: <Faster />,
  },
  {
    title: 'Mais segura',
    subtitle: 'Utilizamos inteligência artificial para garantimos a segurança no processo: ',
    icon: 'shield',
    children: <Safer />,
  },
];

export const LearnMoreModalList: FC = () => {
  const learnMoreModal = useLearnMoreModal();

  const currentStep = useMemo(() => stepsList[learnMoreModal.current], [learnMoreModal.current]);

  return (
    <LearnMoreModal
      currentStep={learnMoreModal.current}
      disabledPrevious={!learnMoreModal.canGoPrev}
      icon={currentStep.icon}
      isOpen={learnMoreModal.isOpen}
      nextText={learnMoreModal.canGoNext ? 'Ver próximo' : 'Fechar'}
      subtitle={currentStep.subtitle}
      title={currentStep.title}
      totalSteps={learnMoreModal.totalSteps}
      onClose={learnMoreModal.close}
      onNext={learnMoreModal.next}
      onOpen={learnMoreModal.open}
      onPrevious={learnMoreModal.prev}
    >
      {currentStep.children}
    </LearnMoreModal>
  );
};
